<template lang="pug">
v-dialog(v-model="shown", persistent, scrollable, width="900")
  Welcome(v-if="!welcomePassed", @next="openCompanyQuiz")

//- v-dialog(:value="true", persistent, scrollable, width="900")
  Welcome(@next="openCompanyQuiz")

  //- v-card(v-else-if="finishCreation")
    .pa-4
      h2.text-center.mb-4 All done!
      p.text-center.mb-4
        | Your company profile has been created.
        br
        | Now, we would recommend
        | to create a tailored case,
        | so you can get valuable insights and guidance
        br
        | on how to become a licensed sponsor
      .btns
        .d-flex.justify-center
          v-btn(color="primary", @click="redirectOnCases")
            | continue
        .d-flex.justify-center.mt-2
          v-btn(text, @click="dialog = false")
            | cancel
</template>

<script>
import Welcome from "./Welcome.vue";

export default {
  components: {
    Welcome,
  },

  data: () => ({
    welcomePassed: false,
  }),

  methods: {
    openCompanyQuiz() {
      this.welcomePassed = true;
      this.$store.dispatch("flows/openQuiz", {
        alias: this.userflow.flow.alias,
      });
    },
  },

  computed: {
    shown: {
      get() {
        return this.userflow?.status === "in progress";
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    userflow() {
      return this.$store.getters["flows/freeCompany"];
    },
  },
};
</script>
